jQuery(document).ready(function ($) {
  $(document).on('submit', '.contato-form', function (event) {
    event.preventDefault()

    $('#captcha-error').css('display', 'none')
    var hasError = 0

    $(this)
      .find('.campo-validacao-obrigatorio')
      .each(function (index, el) {
        if ($(el).val() == '') {
          $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
          hasError = 1
        }
      })

    let captachResponse = grecaptcha.getResponse()

    if (!captachResponse) {
      $('#captcha-error').css('display', 'block')
      hasError = 1
    }

    if (hasError) {
      $(this).find('.contato-form-wrapper').stop().shake(100, 5)
      return false
    }

    var btn = $(this).find('.contato-submit-wrapper .btn')
    var btnHtml = btn.html()
    btn.css('width', '76px').html('<i class="fa fa-spin fa-spinner"></i>')
    btn.attr('disabled', 'disabled')

    $.ajax({
      url: $(this).attr('action'),
      type: 'POST',
      data: $(this).serialize()
    })
      .done(function (data) {
        if (data.status == 'success') {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'form-contato-sucesso'
          });
          
          swal({
            title: 'Sucesso!',
            text: data.message,
            type: 'success'
          })

          grecaptcha.reset()
          $(event.currentTarget).find('textarea').val('')
          btn.css('width', '170px').html('Enviado!')
          btn.removeAttr('disabled')

          setTimeout(function () {
            btn.css('width', '170px').html(btnHtml)
          }, 1200)

          if ($('#imovel-conversion')[0]) {
            $('#remarketing').html($('#imovel-conversion').html())
          }

          $('.sa-button-container .confirm').on('click', function () {
            if ($(window).width() < 1200) {
              $('.modal-geral-fechar').click()
              $('.modal-fechar').click()
            }
          })
        } else {
          swal({
            title: 'Algo deu errado!',
            html: data.message,
            type: 'error'
          })
          btn.css('width', '170px').html('Opsss!')
          btn.removeAttr('disabled')
          setTimeout(function () {
            btn.css('width', '170px').html(btnHtml)
          }, 600)
        }
      })
      .fail(function () {
        swal({
          title: 'Algo deu errado!',
          html: 'Verifique se você preencheu os campos corretamente.',
          type: 'error'
        })
        btn.removeAttr('disabled')
      })

    return false
  })
})
